import axios from 'axios';

const createInstanceSettingsApiInstance = () => {
  const baseURL =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
      ? 'http://localhost:10000/api3.2/admin/settings'
      : '/api3.2/admin/settings';

  return axios.create({ baseURL, withCredentials: true });
};

const instanceSettingsApi = createInstanceSettingsApiInstance();

export default instanceSettingsApi;
